import React from "react";
import { CompanyUserField } from '../../Utilities/Enums/ParametersEnum';

export class CompanyUser {
    [CompanyUserField.PUBLIC_ID]: string | number = 0;
    [CompanyUserField.NAME]: string = "";
    [CompanyUserField.FIRST_NAME]: string = "";
    [CompanyUserField.LAST_NAME]: string = "";
    [CompanyUserField.EMPLOYEE_CODE]: string = "";
    [CompanyUserField.USERNAME]: string = "";
    [CompanyUserField.DATABASE_ID]: string = "";

    constructor(obj?: Partial<CompanyUser>) {
        Object.assign(this, obj);
    }
}

export class AddEditCompanyUsersModalInterface {
    companyid?: number | string;
    companyUsersFormData?: CompanyUser;
    setcompanyUsersFormData?: React.Dispatch<React.SetStateAction<CompanyUser>>;
    openAddEditCompanyUserModal?: boolean;
    setopenAddEditCompanyUserModal?: React.Dispatch<React.SetStateAction<boolean>>;
    getCompanyData?: () => void = () =>{};
}
